import type { BrandRuntimeArtifact, ValidBrandRuntimeArtifact } from '@today/brand-config/runtime'
import { UserRole } from '@today/types'

/** The part of the `/auth/me` viewer the brand binding reads (backoffice-brand-binding). */
export interface BrandViewer {
	role: UserRole
	brandId?: string | null
}

const findValid = (brands: readonly BrandRuntimeArtifact[], id: string): ValidBrandRuntimeArtifact | undefined =>
	brands.find((candidate): candidate is ValidBrandRuntimeArtifact => candidate.valid && candidate.id === id)

/**
 * The brand the backoffice binds for a viewer (ADR-0045 "Themed surfaces", Amendment TO-482):
 * a tenant-scoped viewer gets its tenant's compiled brand; a `SUPER_ADMIN` (the platform
 * backoffice), a signed-out visitor and a viewer with no usable brand get the platform brand.
 *
 * @throws when the platform brand itself is not in `brands` — the bundle must never ship unbranded.
 */
export function selectViewerBrand(
	viewer: BrandViewer | null,
	brands: readonly BrandRuntimeArtifact[],
	platformBrandId: string,
): ValidBrandRuntimeArtifact {
	const platform = findValid(brands, platformBrandId)
	if (!platform) throw new Error(`virtual:today-brands holds no "${platformBrandId}" platform brand`)
	if (!viewer?.brandId || viewer.role === UserRole.SUPER_ADMIN) return platform
	return findValid(brands, viewer.brandId) ?? platform
}
